import NotesComponents from '#/notes/components'

// export store as vue plugin
import NotesStore from '#/notes/store'
export const BriteNotesStore = NotesStore

// export definitions as vue plugin
import { NOTES_READING_MODE, NOTES_MODES, ENVIRONMENTS, NOTES_DOMAINS } from '#/notes/components/definitions'
export const BriteNotesDefinitions = {
  ENVIRONMENTS,
  NOTES_DOMAINS,
  NOTES_MODES,
  NOTES_READING_MODE
}

export const BriteNotes = NotesComponents
export default BriteNotes
